import { register, getPrefix } from '../../../Utils'

const ImageGalleryAlt = el => {
  const prefix = getPrefix(el)

  const initSlider = () => {
    let tns = window.tns
    const sliderContainer = el.querySelector(`.${prefix}carousel-inner`)
    let sliderWidth = el.querySelector(`.${prefix}infobox`).offsetWidth

    const mainSlider = tns({
      container: sliderContainer,
      items: 1,
      loop: true,
      autoHeight: true,
      fixedWidth: sliderWidth,
      center: true,
      nav: false,
      speed: 600,
      autoplay: el.dataset.autoplay || false,
      autoplayButtonOutput: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      prevButton: el.querySelector(`.${prefix}carousel-prev`),
      nextButton: el.querySelector(`.${prefix}carousel-next`)
    })

    const slideSum = ('0' + mainSlider.getInfo().slideCount).slice(-2)
    const countCountainer = el.querySelector(`.${prefix}counter`)
    const infoTextContainer = el.querySelector(`.${prefix}infotext`)
    const titleContainer = el.querySelector(`.${prefix}title`)
    const descriptionContainer = el.querySelector(`.${prefix}description`)
    let activeElement
    let previousElement
    let nextElement
    let prevIndex = 0

    const changeSlideClasses = () => {
      // This logic does, so far ,not work in loop-mode, since in loop-mode the slides will be cloned freshly after some iterations.

      let sliderInfo = mainSlider.getInfo()
      if (activeElement) {
        activeElement.classList.remove(`${prefix}active-slide`)
      }
      if (previousElement) {
        previousElement.classList.remove(`${prefix}previous-slide`)
      }
      if (nextElement) {
        nextElement.classList.remove(`${prefix}next-slide`)
      }

      activeElement = sliderInfo.slideItems[sliderInfo.index]
      previousElement = sliderInfo.slideItems[sliderInfo.index - 1]
      nextElement = sliderInfo.slideItems[sliderInfo.index + 1]

      if (activeElement) {
        activeElement.classList.add(`${prefix}active-slide`)
      }
      if (previousElement) {
        previousElement.classList.add(`${prefix}previous-slide`)
      }
      if (nextElement) {
        nextElement.classList.add(`${prefix}next-slide`)
      }
    }

    changeSlideClasses()

    let counterText = `01/${slideSum}`

    // sliderContainer.style.height = `${activeElement.offsetHeight}px` check if this can be omitted for autoHeight
    countCountainer.innerText = counterText

    const slideChange = (e) => {
      if (prevIndex !== e.displayIndex) {
        infoTextContainer.classList.add(`${prefix}is--hidden`)

        changeSlideClasses()

        setTimeout(() => {
          titleContainer.innerHTML = activeElement.dataset.title
          descriptionContainer.innerHTML = activeElement.dataset.description

          infoTextContainer.classList.remove(`${prefix}is--hidden`)
        }, 300)

        counterText = `${('0' + e.displayIndex).slice(-2)}/${slideSum}`
        countCountainer.innerText = counterText
      }
      prevIndex = e.displayIndex
      // sliderContainer.style.height = `${activeElement.offsetHeight}px` check if this can be omitted for autoHeight
    }

    mainSlider.events.on('indexChanged', slideChange)
  }

  initSlider()
}

register('ImageGalleryAlt', ImageGalleryAlt)
